import {
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Grid,
  Group,
  LoadingOverlay,
  Radio,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { apiPOS } from "../../library/axios";
import { MessageResponse } from "../../model/MessageResponse";
import { WorkingTimeItemModel } from "../../model/WorkingTimeItem";

type Props = {
  idEdit?: string | number;
  onClose: any;
};
const Form = ({ idEdit, onClose }: Props) => {
  const entity = {
    id: 0,
    moHinh: null,
    chiNhanh: null,
    thoiGianMoDong: null,
    dongNghiTrua: true,
    dienGiai: null,
    iconSapKhaiTruong: null,
    iconDaMoBan: null,
    soDienThoai: null,
    banDo: null,
    hinhAnh: null,
    diaChi: null,
    email: null,
    trangThaiHoatDong: null,
    isHot: null,
    soDienThoaiBaoHanh: null,
    linkImage: null,
    linkGgMapIframe: null,
    vungMien: null,
  };

  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<any>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      chiNhanh: (value: string) => (value ? null : "Vui lòng nhập chi nhánh!"),
      diaChi: (value: string) => (value ? null : "Vui lòng nhập địa chỉ!"),
      soDienThoai: (value: string) =>
        value ? null : "Vui lòng nhập số điện thoại liên hệ!",
      email: (value: string) => (value ? null : "Vui lòng nhập email!"),
      vungMien: (value: string) => (value ? null : "Vui lòng chọn vùng miền!"),
      // linkImage: (value: string) =>
      //   value ? null : "Vui lòng điền link hình ảnh",
      thoiGianMoDong: (value: string) =>
        value ? null : "Vui lòng nhập thời gian mở cửa!",
      // trangThaiHoatDong: (value: boolean) =>
      //   value ? null : "Vui lòng chọn trạng thái hoạt động!",
      // attribute1: (value: string | null) =>
      //   !value ? "Vui lòng chọn chi nhánh (POS) !" : null,
    },
  });
  const handleSubmit = async (dataSubmit: WorkingTimeItemModel) => {
    open();
    try {
      const apiUrl = idEdit
        ? `/api-mdm/api/v1/TblThoiGianLamViec/update`
        : `/api-mdm/api/v1/TblThoiGianLamViec/create`;
      console.log("dataSubmit:", dataSubmit);
      const dataApi = await apiPOS.post<MessageResponse<WorkingTimeItemModel>>(
        apiUrl,
        { ...dataSubmit },
      );
      if (dataApi?.data && dataApi?.data?.success) {
        onClose((prev: any) => !prev);
        modals.closeAll();
        {
          idEdit
            ? NotificationExtension.Success("Cập nhật thành công")
            : NotificationExtension.Success("Tạo mới thành công");
        }
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      close();
    }
  };
  const callApiGetData = async () => {
    if (!idEdit) return;
    open();
    const callapi = await apiPOS.get<MessageResponse<WorkingTimeItemModel>>(
      `/api-mdm/api/v1/TblThoiGianLamViec/get-update?id=${idEdit}`,
    );
    if (callapi && callapi.data && callapi.data.success) {
      const dataApi = callapi?.data.data;
      if (dataApi != null) {
        form.setValues(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };
  const getDataBranch = async () => {
    try {
      const res = await apiPOS.get<MessageResponse<any>>(
        "/api-shipping/api/v1/TblDmMasterOrg/get-select",
      );

      if (res && res.data && res.data.success) {
        const data = res.data.data;
        const dataSet = data
          .filter((i: any) => i.att1 && i.value && i.text)
          .map((i: any) => ({
            label: `${i.att1} - ${i.text}`,
            value: String(i.value),
          }));
        setDataBranch(dataSet);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    callApiGetData();
  }, [idEdit]);
  useEffect(() => {
    getDataBranch();
  }, []);
  console.log("form.getValue()", form.getValues());
  return (
    <Box
      component="form"
      mx="auto"
      onSubmit={form.onSubmit(handleSubmit)}
      style={{ position: "relative", width: "600px" }}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />

      <Grid mt="md">
        <Grid.Col span={6}>
          <TextInput
            label="Chi nhánh"
            withAsterisk
            placeholder="HACOM - HAI BÀ TRƯNG"
            key={form.key("chiNhanh")}
            {...form.getInputProps("chiNhanh")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Địa chỉ"
            withAsterisk
            placeholder="Số 131 Lê Thanh Nghị - Bạch Mai - Hà Nội"
            key={form.key("diaChi")}
            {...form.getInputProps("diaChi")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Hình ảnh thực tế từ showroom"
            placeholder="https://hacom.vn/hinh-anh-thuc-te-showroom-hai-ba-trung"
            key={form.key("hinhAnh")}
            {...form.getInputProps("hinhAnh")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Bản đồ đường đi"
            placeholder="https://maps.app.goo.gl/3KB3gRdVuuVTq1DM7"
            key={form.key("banDo")}
            {...form.getInputProps("banDo")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Số điện thoại liên hệ"
            withAsterisk
            placeholder="Tel: 1900 1903 (máy lẻ 25399) - (0247) 3020386"
            key={form.key("soDienThoai")}
            {...form.getInputProps("soDienThoai")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Số điện thoại bảo hành"
            placeholder="Bảo hành: 1900 1903 (máy lẻ 25393)"
            key={form.key("soDienThoaiBaoHanh")}
            {...form.getInputProps("soDienThoaiBaoHanh")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Email"
            withAsterisk
            placeholder="kdbl.haibatrung@hacom.vn"
            key={form.key("email")}
            {...form.getInputProps("email")}
          />
        </Grid.Col>
        {/* <Grid.Col span={6}>
          <Checkbox
            label="Hiển thị icon sắp khai trương"
            checked={!!form.getValues().iconSapKhaiTruong}
            disabled={form.getValues().iconDaMoBan}
            onChange={(event) => {
              form.setFieldValue(
                "iconSapKhaiTruong",
                event.currentTarget.checked
              );
            }}
            key={form.key("iconSapKhaiTruong")}
          />
        </Grid.Col> */}
        {/* nếu đang tích sắp khai trương thì bỏ tích đã mở bán và ngược lại */}
        {/* <Grid.Col span={6}>
          <Checkbox
            label="Hiển thị icon đã mở bán"
            checked={!!form.getValues().iconDaMoBan}
            disabled={form.getValues().iconSapKhaiTruong}
            onChange={(event) => {
              form.setFieldValue("iconDaMoBan", event.currentTarget.checked);
            }}
            key={form.key("iconDaMoBan")}
          />
        </Grid.Col> */}
        <Grid.Col span={6}>
          <TextInput
            label="Text Hot"
            placeholder="Sắp khai trương"
            key={form.key("isHot")}
            {...form.getInputProps("isHot")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Link ảnh hiển thị ở showroom:"
            placeholder="https://hanoicomputercdn.com/media/lib/26-02-2024/1hn_hbt.jpg"
            key={form.key("linkImage")}
            {...form.getInputProps("linkImage")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Nhúng iframe Map:"
            placeholder="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.7740152811957!2d105.8378666792194!3d21.00169393072464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135addd9fd46d5b%3A0x507a55e8748aa104!2zSEFDT00gSEFJIELDgCBUUsavTkc!5e0!3m2!1svi!2s!4v1744970626602!5m2!1svi!2s"
            key={form.key("linkGgMapIframe")}
            {...form.getInputProps("linkGgMapIframe")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <Radio.Group
            label="Vùng miền dành cho phân loại ở button header"
            name="vungMien"
            key={form.key("vungMien")}
            value={form.getValues().vungMien}
            // {...form.getInputProps("vungMien")}
            onChange={(value) => {
              form.setFieldValue("vungMien", value);
            }}
            withAsterisk
          >
            <Group mt="xs">
              <Radio value="mienBac" label="Miền Bắc" />
              <Radio value="mienTrung" label="Miền Trung" />
              <Radio value="mienNam" label="Miền Nam" />
            </Group>
          </Radio.Group>
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Thời gian mở cửa:"
            placeholder="Thời gian mở cửa: Từ 8h-19h hàng ngày"
            key={form.key("thoiGianMoDong")}
            withAsterisk
            {...form.getInputProps("thoiGianMoDong")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            label="Thời gian nghỉ trưa:"
            placeholder="Ví dụ: Thời gian nghỉ trưa: Từ 12h-13h30 hàng ngày"
            key={form.key("dienGiai")}
            {...form.getInputProps("dienGiai")}
          />
        </Grid.Col>{" "}
        <Grid.Col span={6}>
          <Select
            key={form.key("attribute1")}
            label="Chi nhánh (POS)"
            placeholder="Chọn chi nhánh"
            data={dataBranch}
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            {...form.getInputProps("attribute1")}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextInput
            key={form.key("attribute2")}
            label="STT"
            placeholder="Nhập STT"
            {...form.getInputProps("attribute2")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Checkbox
            label={<span>Hoạt động</span>}
            checked={!!form.getValues().trangThaiHoatDong}
            onChange={(event) => {
              form.setFieldValue(
                "trangThaiHoatDong",
                event.currentTarget.checked,
              );
            }}
            key={form.key("trangThaiHoatDong")}
            error={form.errors.trangThaiHoatDong}
          />
        </Grid.Col>
      </Grid>

      <Box mt="md" style={{ textAlign: "right" }}>
        <Button type="submit" loading={visible}>
          Lưu
        </Button>
      </Box>
    </Box>
  );
};

export default Form;
